/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import env from '../../../common/env';
import { MIXPANEL_EVENTS, MIXPANEL_EVENT_METADATA } from '../../../common/MixPanelConstants';

export const getTenantTrackingProperties = (tenant = {}) => ({
  tenantId: tenant.tenantId || tenant.id || '',
  tenantName: tenant.name || tenant.tenantName || '',
  tenantTitle: tenant.title || tenant.tenantTitle || ''
});

export const getAppFromPath = (pathname = window.location.pathname) => {
  const [root, , module] = pathname.split('/').filter(Boolean);

  if (root === 'berlin' && module) {
    return `${root}-${module}`;
  }

  if (root === 'aiadmin') {
    return module || 'ai-admin';
  }

  return root || 'ai-admin';
};

const getCommonProperties = () => ({
  app: getAppFromPath(),
  path: window.location.pathname
});

const isMixpanelReady = () => Boolean(env.MIXPANEL_TOKEN && typeof window.mixpanel?.track === 'function');

export const initMixpanel = () => {
  if (!env.MIXPANEL_TOKEN || typeof window.mixpanel?.init !== 'function') return;
  window.mixpanel.init(env.MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100
  });
};

export const trackEvent = (eventName, properties = {}) => {
  if (!isMixpanelReady() || !eventName) return;
  window.mixpanel.track(eventName, {
    ...getCommonProperties(),
    ...MIXPANEL_EVENT_METADATA[eventName],
    ...properties
  });
};

export const trackStudioEvent = (eventName, tenant, properties = {}) => {
  trackEvent(eventName, {
    ...getTenantTrackingProperties(tenant),
    ...properties
  });
};

export const identifyUser = (user) => {
  if (!isMixpanelReady() || !user?.userId) return;
  window.mixpanel.identify(user.userId);
  window.mixpanel.people.set({
    $user_id: user.userId,
    loginTime: new Date().toISOString()
  });
  trackEvent(MIXPANEL_EVENTS.USER_LOGIN_SUCCESS, {
    userId: user.userId
  });
};
